export enum DocumentStatusCode {
  New = 'NEW',
  InProgress = 'INP',
  Completed = 'CMP',
}
